module.exports = __webpack_public_path__ + "img/brushes-jp-4.2c50e5d.jpg";